import api from "api";


export function getCovinData(startDate, endDate, page=1) {
  return api.get(`convin-dashboard?startDate=${startDate}&endDate=${endDate}&pageNumber=${page}&pageSize=10`);
}

export function downloadCovinReport(startDate, endDate) {
  return api.get(`download-convin-report?startDate=${startDate}&endDate=${endDate}`)
}